import { Injectable } from '@angular/core';
import { HttpClient2 } from './http-client.service';
import { Observable } from 'rxjs/Observable';
import { IResultado } from '../commons/interfaces';
import { EntidadFinanciera } from '../models/entidadFinanciera';

@Injectable()
export class EntidadFinancieraService {
  ciaId : string;

  constructor(private http : HttpClient2) {
    let currentUser  = JSON.parse(localStorage.getItem("currentUser"));
    this.ciaId = currentUser.esEmpresaTransporteAdministrador? "/"+currentUser?.companiaPadre: "/"+currentUser.compania.companiaId;
  }

  listar() : Observable<Array<EntidadFinanciera>>{
    return this.http.listar("/entidad-financiera").map(
      (data: IResultado) => {
        let list = Array<EntidadFinanciera>();
        let obj;
        if(data){
          for (const d of data.resultado) {
            obj = new EntidadFinanciera();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
      }
    );
  }

}
